/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import CommonService from "../../API/Common";
import ProductService from "../../API/Product";
import truckimg from "../../assets/images/truckimg.jpeg";
import Loader from "../../Common/Loader";
import LoadImage from "../../Common/LoadImage";
import ROUTES from "../../routes";
import { VALIDATIONS } from "../../Utils/constants";
import leftArrow from "../../assets/images/left-arrow.svg";
import { convertToUrlFormat, geturl, NotificationWithIcon } from "../../Utils/helper";
import { useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
import phoneIcon from "../../assets/images/phone-call.svg";
import { Col, Form, Row } from "antd";
import { Field, Formik } from "formik";
import { Button, Container } from "react-bootstrap";
import { contactValidation } from "../../Utils/validations";
import { getErrorMessage } from "../../Utils/helper";


const trackPhoneClick = (eventName: string) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", eventName, {
      event_category: "Phone",
      event_label: eventName,
    });
  }
};

const LandingPage = () => {
  const [loader, setLoader] = useState<any>(false);
  const [setCategories] = useState<any>([]);
  const [sliderImg, setSliderImgs] = useState<any>([]);
  const [productCategory, setProductCategory] = useState<any>([]);
  const [shouldScroll, setShouldScroll] = useState(false);
  const [metaTitle,setMetaTitle] = useState("Home | SkyAzul");
  const location = useLocation();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const getError = (err: any) => {
    console.log(err);
    setLoader(false);
  };

  useEffect(() => {
    if (location.state?.scrollToSection) {
      setShouldScroll(true);
    }
  }, [location]);

  useEffect(() => {
    if (shouldScroll) {
      const element = document.getElementById(location.state.scrollToSection);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
      setShouldScroll(false);
    }
  }, [shouldScroll, location.state]);


  const getHomeSliders = async () => {
    setLoader(true);
    await CommonService.getHomeSliders()
      .then((res: any) => {
        if (res && res?.status === "Success") {
          setLoader(false);
          setSliderImgs(res?.data?.images);
        }
      })
      .catch((err: any) => {
        getError(err);
      });
  };

  const getHomeCategoryList = async () => {
    setLoader(true);
    await ProductService.getCategoryList()
      .then((res: any) => {
        if (res && res?.status === "Success") {
          setLoader(false);
          setCategories(res?.data);
        }
      })
      .catch((err: any) => {
        getError(err);
      });
  };

  const getProductCategoryList = async () => {
    setLoader(true);
    await ProductService.getAllReadOnlyProductCategories(
      "all=true&populate[images][fields]=url"
    )
      .then((res: any) => {
        setLoader(false);
        if (res && res?.status === "Success") {
          setProductCategory(res?.data);
        }
      })
      .catch((err: any) => {
        getError(err);
      });
  };

  const getCountryList = async () => {
    await CommonService.getCountry()
      .then((res: any) => {
        if (res && res?.data) {
          localStorage.setItem("countryList", JSON.stringify(res?.data));
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    async function getHomePageInfo() {
      await getHomeSliders();
      await getHomeCategoryList();
      await getProductCategoryList();
      await getCountryList();
    }
    getHomePageInfo();
  }, []);

  useEffect(() => {
    setMetaTitle("Monitoring Systems for Construction & Mining - SkyAzúl"); 
  }, []);

    const onSend = async (
    values: {
      name: string;
      email: string;
      subject: string;
      message: string;
    },
    resetForm: any
  ) => {
    setLoader(true);
    const data: Object = {
      name: values.name.trim(),
      email: values.email,
      subject: values.subject.trim(),
      message: values.message.trim(),
    };
    await CommonService.sendContactDetails(data)
      .then((res: any) => {
        if (res?.status === "Success") {
          setLoader(false);
          if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
            window.gtag('event', 'contact_form_submission', {
              event_category: 'Contact',
              event_label: 'Contact Us Form',
              value: 1
            });
          }
          NotificationWithIcon("success", VALIDATIONS.CONTACT_SUCCESS);
          resetForm();
          navigate(ROUTES.THANKYOU);
        }
      })
      .catch((err: any) => {
        setLoader(false);
        NotificationWithIcon(
          "error",
          err?.data?.error?.message || VALIDATIONS.SOMETHING_WENT_WRONG
        );
      });
  };

  return (
    <>
      <Helmet>
     <title>{metaTitle}</title>
     <meta name="robots" content="noindex, nofollow" />
     <meta property="og:title" content="Monitoring Systems for Construction & Mining - SkyAzúl" />
     <meta
          property="og:description"
          content="SkyAzúl Equipment Solutions is a proven leader in the sales and service of monitoring systems 
                  for construction and mining equipment.
                 We offer a full range of information and monitoring systems."
        />
        <meta
          property="og:url"
          content={`${window.location.origin}${ROUTES.HOME}`}
        />
     </Helmet>
      {loader && <Loader />}
      <div>
        <Carousel className="banner-slider">
          {sliderImg?.length > 0 &&
            sliderImg.map((sliderObj: any) => {
              return (
                <Carousel.Item key={sliderObj?.id}>
                  <img
                    className="d-block w-100"
                    src={sliderObj?.url ? geturl(sliderObj?.url) : truckimg}
                    alt="First slide"
                  />
                </Carousel.Item>
              );
            })}
        </Carousel>
      </div>
      <div className="about-block">
        <div className="container">
          <div className="row">
            <div className="col-md-4 ps-5">
              <p className="block-title-xxl text-dark">WELCOME TO SKYAZUL</p>
            </div>
            <div className="col-md-8">
              <div className="max-width-648">
                <p className="cmn-txt cmn-txt-md mb-3">
                  SkyAzúl Equipment Solutions is a proven leader in the sales
                  and service of monitoring systems for construction and mining
                  equipment. We offer a full range of information and monitoring
                  systems for heavy equipment, from the most basic Anti-Two
                  Block System for mobile cranes to the most complex Load Moment
                  Indicators. Our Powerline Proximity Warning Systems for
                  Construction Equipment and Aerial Platforms are the most
                  user-friendly and accurate in the industry. We provide
                  comprehensive technical support, including field service.
                </p>
                <ul className="list-unstyled ms-auto mb-0 d-flex pe-3">
                            <li className="d-flex align-items-center me-152">
                              <img src={phoneIcon} alt="Phone icon" className="me-2" />
                              <div className="display" >
                                <p className="cmn-txt mb-0">Phone Services</p>
                                <h4 className="block-title block-title-md mb-0">
                                  <a
                                    href="tel:3013716126"
                                    onClick={() => trackPhoneClick('phone_number_1_clicked')}
                                  >
                                    (301) 371-6126
                                  </a>
                                </h4>
                                <h4 className="block-title block-title-md mb-0">
                                  <a
                                    href="tel:2812013690"
                                    onClick={() => trackPhoneClick('phone_number_2_clicked')}
                                  >
                                    (281) 201-3690
                                  </a>
                                </h4>
                              </div>
                              
                            </li>
                          </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {productCategory?.length > 0 && (
         <div id="product-section" className="product-categories-block">
          <div className="container">
            <div className="row">
              <div className="col-md-12 mb-3 text-center">
                <h1 className="block-title-xxl text-white">
                SkyAzul Product Categories
                </h1>
              </div>
            </div>
            <div className="row">
              {productCategory.map((catObj: any) => {
                return (
                  <div className="col-md-4 mb-4" key={catObj?.id}>
                    <div className="product-img-box">
                      <LoadImage
                        src={catObj?.images?.[0]?.url}
                        inlineClass="img-fluid img-cursor"
                        onClick={() =>
                          navigate(`/readonly-categories/${catObj.id}/${convertToUrlFormat(catObj.name)}`, {
                            state: { category: catObj },
                          })
                          
                        }
                        alt={`SkyAzul product category - ${catObj?.name}`}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      <div className="online-store-block">
        <div className="container position-relative">
          <div className="row mb-4">
            <div className="col-md-12 text-center">
              <h4 className="block-title-xxl text-dark mb-0">Contact Us</h4>
              <p className="cmn-txt cmn-txt-md mb-0">
                We can help. Our team of experts is on hand to answer your
                questions.
              </p>
            </div>
          </div>
          <Container className="fixed-width-container">
            <Formik
              initialValues={{
                name: "",
                email: "",
                subject: "",
                message: "",
              }}
              onSubmit={(values: any, { resetForm }) => {
                onSend(values, resetForm);
              }}
              validationSchema={contactValidation}
              validateOnBlur={false}
            >
              {({ handleSubmit }) => (
                <Form
                  layout="vertical"
                  form={form}
                  onSubmitCapture={handleSubmit}
                >
                  <Row gutter={16}>
                    <Col className="col-lg-6 col-12">
                      <Form.Item
                        label="First name*"
                        className="custom-field mb-3"
                      >
                        <Field
                          id="name"
                          name="name"
                          placeholder="Enter your name"
                          className="form-control custom-form-control"
                        />
                        {getErrorMessage("name")}
                      </Form.Item>
                    </Col>
                    <Col className="col-lg-6 col-12">
                      <Form.Item
                        label="Email address*"
                        className="custom-field mb-3"
                      >
                        <Field
                          id="email"
                          name="email"
                          placeholder="Enter your email"
                          className="form-control custom-form-control"
                        />{" "}
                        {getErrorMessage("email")}
                      </Form.Item>
                    </Col>
                    <Col className="col-lg-12 col-12">
                      <Form.Item label="Subject*" className="custom-field mb-3">
                        <Field
                          id="subject"
                          name="subject"
                          placeholder="Enter your subject"
                          className="form-control custom-form-control"
                        />{" "}
                        {getErrorMessage("subject")}
                      </Form.Item>
                    </Col> 
                    <Col className="col-lg-12 col-12">
                      <Form.Item label="Message*" className="custom-field mb-2">
                        <Field
                          id="message"
                          name="message"
                          placeholder="Enter your Message here...."
                          className="form-control custom-form-control"
                          component="textarea"
                          rows={5}
                        />{" "}
                        {getErrorMessage("message")}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item className="mt-3 text-center">
                    <Button
                      type="submit"
                      className="w-100 btn--primary btn w-200"
                    >
                      Get A Quote{" "}
                      <img
                        src={leftArrow}
                        alt="Arrow icon for Get a Quote button"
                        className="ms-2"
                      />
                    
                    </Button>
                  </Form.Item>
                </Form>
              )}
            </Formik>
          </Container>
        </div>
      </div>

    </>
  );
};

export default LandingPage;

